var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-me_grey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "me_grey",
    clipPath: "url(#clip-me_grey)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17330",
    "data-name": "Path 17330",
    d: "M10.6,8.025A6.183,6.183,0,0,0,8.237,6.546a3.588,3.588,0,1,0-4.061,0A6.217,6.217,0,0,0,0,12.414H.97a5.237,5.237,0,1,1,10.474,0h.97A6.167,6.167,0,0,0,10.6,8.025ZM6.207,6.207A2.619,2.619,0,1,1,8.826,3.588,2.622,2.622,0,0,1,6.207,6.207Z",
    transform: "translate(1.582 1.582)",
    fill: "#34495e",
    stroke: "#34495e",
    strokeWidth: 0.5,
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeGrey);
export default __webpack_public_path__ + "static/media/me_grey.c08e10784f1a472505e8692a1c41315f.svg";
export { ForwardRef as ReactComponent };